module.exports = __webpack_public_path__ + "py.908cf1b2dc08c382d03c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/py.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/py.svg
// module chunks = styles